import logger from '../../utils/logger';

const GPT_COLOR = '#4081ED';

export default (...arg) => {
  // eslint-disable-next-line no-console
  logger.log({
    msg: arg,
    config: {
      title: 'GOOGLE-ADS : ',
      color: GPT_COLOR,
      bgColor: 'none',
      // eslint-disable-next-line no-underscore-dangle
      enabled: true // window.__logads
    }
  });
};
